var map = {
	"./bg_business_h2.png": "+kCm",
	"./bg_business_h4.png": "oH60",
	"./bg_business_h9.png": "GTQW",
	"./bg_home.png": "EnP/",
	"./brightness_arrow.png": "oy6c",
	"./brightness_bg.png": "1GuA",
	"./btn_move-x.png": "iHfM",
	"./btn_move.png": "VIcB",
	"./btn_move_hover-x.png": "2KBN",
	"./btn_move_hover.png": "hGbl",
	"./business_chair_h2_l.png": "dGqD",
	"./business_chair_h2_r.png": "Pb3w",
	"./business_chair_h4_l.png": "QziV",
	"./business_chair_h4_r.png": "TfXi",
	"./business_chair_h9_l.png": "vhOA",
	"./business_chair_h9_r.png": "Fx0K",
	"./hexagon.png": "0mI2",
	"./home_sofa.png": "fFc6",
	"./home_sofa_c.png": "4XMc",
	"./icon_setting.png": "T/k2",
	"./img_P.png": "zp3T",
	"./img_P_projection.png": "r5xe",
	"./line_throw distance.png": "XflN",
	"./octagon.png": "ZiCG",
	"./people.png": "bZZy",
	"./quadrilateral.png": "R0Mr",
	"./screen.png": "Ioco",
	"./simpleui_projector.png": "ZQKr",
	"./simpleui_projector_lx_down.png": "VstS",
	"./simpleui_projector_lx_up.png": "Tz/O"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "n9nA";


//////////////////
// WEBPACK FOOTER
// ./src/assets/parts/simple ^\.\/.*\.png$
// module id = n9nA
// module chunks = 3